import { render, staticRenderFns } from "./gFieldset.vue?vue&type=template&id=145b236d&scoped=true&"
import script from "./gFieldset.vue?vue&type=script&lang=js&"
export * from "./gFieldset.vue?vue&type=script&lang=js&"
import style0 from "./gFieldset.vue?vue&type=style&index=0&id=145b236d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145b236d",
  null
  
)

export default component.exports